import {Common} from '../shared/common';

declare var levote_JSONSerialObj: any;
declare var levote_JSONSerial: any;
declare var levote_Voter: any;
declare var levote_VoterPrivateKeyObj: any;

import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation, OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { Ballot, Choice, Poll, PollStatus, ReceivedQuestion, VotingEvent, TestResult } from '../shared/model/poll.model';
import { environment } from 'src/environments/environment.staging';
import { ApiService } from "../shared/api.service";
import { ErrorList } from '../poll-detail/interfaceEnums';
import { enc, SHA256 } from 'crypto-js';
import { ActivatedRoute } from '@angular/router';
import {AuthError} from '../dynamic-display/dynamic-display.component';

@Component({
  selector: 'app-list-poll',
  templateUrl: 'list-poll.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./list-poll.component.less', '../shared/common.less'],
})

export class ListPollComponent implements OnInit, OnChanges {
  @Input() isClosed: boolean = false;
  @Input() firstname: string;
  @Input() lastname: string;
  @Input() email: string;
  @Input() poll: VotingEvent = null;
  @Input() testPoll: VotingEvent = null;
  @Input() endDate: string = '';
  @Input() startDate: string = '';
  @Input() isMobile: boolean = false;
  @Input() index: number;
  @Input() privateKey: string;
  @Input() validation: string = '';
  @Input() votedStatuses: boolean[] = [];
  @Input() isValidated: boolean = true;
  @Input() userPhoneNumber: string = '';
  @Input() userRetriesRemaining: number;
  @Input() isValidationCodeError = false;
  @Input() validationErrorObj: AuthError;
  @Input() noMoreSMS = false;
  @Input() isValidatedPass = true;
  @Input() isValidatedSms = true;
  @Input() isWrongPhoneError = false;
  @Input() smsSent: boolean = false;
  @Input() isTestModeActive: boolean = false;
  @Input() notYetOpen = false;
  @Output() selected = new EventEmitter<number>();
  @Output() twoFaSubmissionEvent = new EventEmitter<string>();
  @Output() sendSMSEvent = new EventEmitter<boolean>();
  @Output() passwordSubmissionEvent = new EventEmitter<string>();
  @Output() sendPhoneEvent = new EventEmitter<string>();
  @Output() sendSmsFirstEvent = new EventEmitter();

  PollStatus = PollStatus;
  voteHash: string = '';
  isDescriptionExpanded: boolean = false;
  blockchainUrl: string;
  pollId: string = '';
  electionSelected: number = -1;
  listSelected: number = -1;
  displayedCandidates: Array<ReceivedQuestion> = [];
  localAnswers: number[] = [];
  isVoteValid: boolean = true;
  currentList: number = -1;
  validateVotePopup: boolean = false;
  indexes: Array<Array<number>> = [];
  responses: number[][] = [];
  activePoll: Poll;
  cryptoChoices: Choice[][] = [];
  errorMessage: string;
  errorTitle: string;
  errorCanRetry: boolean;
  votingProof: string;
  testHash: String = "";
  status: PollStatus;
  isVotingAnimation: boolean;
  isError: boolean;
  results: Array<Array<Array<number>>> = [];
  testResults: Array<Array<number>> = [];
  // testDisplayedCandidates: Array<ReceivedQuestion> = [];
  testDisplayedCandidates: Array<TestResult> = [];
  shouldDisplayTestBallot: boolean = false;
  displayHashPopup: boolean = false;
  ballotSha: any;
  isLoadingCandidates: boolean = false;
  finalVote: Ballot;
  image: string = '';
  hasLoadedPart = false;

  constructor(
    private apiService: ApiService, private route: ActivatedRoute, private cdr: ChangeDetectorRef, private common: Common
  ) {
  }

  resetWalkthrough() {
    this.initResults()
    this.testHash = "";
    this.listSelected = -1;
    this.electionSelected = -1;
    this.localAnswers = [];
    this.currentList = -1;
    this.testDisplayedCandidates = [];
    this.shouldDisplayTestBallot = false;
  }

  /*
  ** 2FA functions
  */

  validateSMS($event: string) {
    this.twoFaSubmissionEvent.emit($event);
  }

  resendSMS() {
    this.sendSMSEvent.emit(true);
  }

  validatePassword($event: string) {
    this.passwordSubmissionEvent.emit($event);
  }

  setupPhone($event: string) {
    this.sendPhoneEvent.emit($event);
  }

  sendFirstSms() {
    this.sendSmsFirstEvent.emit();
  }

  /*
  ** End 2FA functions
  */

  votingPopup() {
    this.testDisplayedCandidates = [];
    this.results[this.electionSelected][this.listSelected] = [...this.localAnswers];

    this.currentList = this.listSelected
    this.setListAnswered();
    let i = 0
    this.poll.rounds[this.electionSelected].displayedQuestions.forEach((question, questionIndex) => {
      if (question.parent != null && question.parent == this.listSelected) {

        if (this.results[this.electionSelected][this.currentList][i] == 1) {
          this.testDisplayedCandidates.push(new TestResult(question.question, question.links,
            question.listImages,
            question.listLink, true));
          i++
        } else {
          this.testDisplayedCandidates.push(new TestResult(question.question, question.links,
            question.listImages,
            question.listLink, false));
          i++
        }
      }
    });
    this.isLoadingCandidates = true;
    this.cdr.detectChanges(); // Force la détection du changement

    // Utiliser setTimeout pour permettre à Angular de mettre à jour la vue
    setTimeout(() => {
      this.calculateVote();
      this.isLoadingCandidates = false;
      this.validateVotePopup = true;
    }, 0);
  }

  validateVote($event: boolean) {
    if ($event) {
      this.actionVote()
      this.validateVotePopup = false;
    } else {
      this.validateVotePopup = false;
    }
  }

  setListAnswered() {
    let formattedVote = [];
    this.results[this.electionSelected][this.currentList].forEach((answer) => {
      formattedVote.push([answer === 1 ? 1 : 0, answer === 1 ? 0 : 1]);
    });
    let innerIndex = 0;
    this.poll.rounds[this.electionSelected].displayedQuestions.forEach((q, index) => {
      if (index == 0) {
        this.indexes = [];
        const arraySize = this.poll.rounds[this.electionSelected].displayedQuestions[0].answers.length;
        const choiceArray = new Array(arraySize).fill(0);
        choiceArray[this.currentList] = 1;
        this.indexes.push(choiceArray);
      }
      if (q.parent === this.currentList && index != 0) {

        this.indexes.push(formattedVote[innerIndex]);
        innerIndex++;
      }
      if (q.parent !== this.currentList && index != 0) {
        this.indexes.push([0, 1]);
      }
    });
    this.responses = JSON.parse(JSON.stringify(this.indexes));
    // console.log("RESPONSES", this.responses);




    // const ansQuest = this.poll.rounds[this.electionSelected].displayedQuestions.map((x, index) => ({val: x.parent === this.liveActiveResolution, i: index}));
    // const fillIndexes = ansQuest.filter(x => x.val === true).map(y => y.i);
    // fillIndexes.forEach((value, index) => {
    //   this.indexes[value] = $event[index] === 1 ? [1, 0] : [0, 1];
    // });
    // this.responses =  JSON.parse(JSON.stringify(this.indexes));
    //this.status = PollStatus.listVote;
    //this.liveActiveResolution = 0;
  }

  setVoteSuccessMessage() {
    this.isVotingAnimation = false;
    this.status = PollStatus.voted;
    //this.refreshParticipation(this.activePoll.round);
    this.getVoteHash();
    if (!this.isTestModeActive) {
      this.displayHashPopup = true;
    }
  }

  getVoteHash() {
    this.voteHash = this.sha(this.votingProof);
    if (!this.isTestModeActive)
      this.sendVoteConfirmationByMail(this.voteHash);
  }

  sendVoteConfirmationByMail(hash: string) {
    this.apiService.sendVoteConfirmation(this.pollId, hash, this.privateKey, this.activePoll.round).subscribe((res) => {
      console.log(res);
    }, (err) => {
      console.log(err);
    });
  }

  closeHashPopup(election: number) {
    if (election !== -1) {
      this.setActiveElection(election)
    } else {
      this.resetWalkthrough()
    }
    this.displayHashPopup = false;
    this.hasLoadedPart = false;
  }

  sha(data) {
    const s = JSON.stringify(data);
    return SHA256(s).toString(enc.Hex);
  }

  getVotedStatus() {
    this.hasLoadedPart = false;
    this.apiService.getVotedStatus(this.pollId, this.validation).subscribe((res: Array<Date>) => {
      this.votedStatuses = res.map(r => r !== null);
      this.hasLoadedPart = true;
      // this.setVoteSuccessMessage();
      if (this.votedStatuses.indexOf(false) === -1) {
        const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' };
        const dateString = new Date(res[res.length - 1]).toLocaleTimeString('fr-FR', options);
        if (this.status !== PollStatus.voted) { this.createAlreadyVotedError(dateString); }
      }
    }, (err) => { this.hasLoadedPart = true; });
  }

  availableElections(): boolean {
    return this.votedStatuses.some(status => status === false)
  }

  getVotingError(reason: string, optional: string = null) {
    let messageList: ErrorList;
    // Utiliser la langue par défaut (français) en attendant
    messageList = {
      closed: { title: 'Scrutin clôturé', canRetry: false, description: 'votre bulletin ne peut plus être déposé dans l\'urne' },
      retry: { title: 'Veuillez recommencer', canRetry: true, description: 'votre bulletin de vote n\'a pu être déposé dans l\'urne' },
      voted: { title: 'Vous avez déjà voté.', canRetry: false, description: 'votre bulletin de vote a déjà été déposé dans l\'urne' },
      blankVote: { title: 'Le Vote blanc est exclusif.', canRetry: true, description: 'Veuillez recommencer en actualisant votre page' },
      votedAt: { title: 'Vous avez déjà voté.', canRetry: false, description: 'votre bulletin de vote a déjà été déposé dans l\'urne le ' }
    } as ErrorList;

    switch (reason) {
      case 'closed': {
        this.errorTitle = messageList.closed.title;
        this.errorCanRetry = messageList.closed.canRetry;
        this.errorMessage = messageList.closed.description;
        break;
      }
      case 'retry': {
        this.errorTitle = messageList.retry.title;
        this.errorCanRetry = messageList.retry.canRetry;
        this.errorMessage = messageList.retry.description;
        break;
      }
      case 'blankVote': {
        this.errorTitle = messageList.blankVote.title;
        this.errorCanRetry = messageList.blankVote.canRetry;
        this.errorMessage = messageList.blankVote.description;
        break;
      }
      case 'voted': {
        this.errorTitle = messageList.voted.title;
        this.errorCanRetry = messageList.voted.canRetry;
        this.errorMessage = optional === null ? messageList.voted.description : messageList.votedAt.description + optional;
        break;
      }
    }

  }

  createAlreadyVotedError(date: string = null) {
    this.status = PollStatus.alreadyVoted;
    this.getVotingError('voted', date);
  }

  createBlankVoteError() {
    this.status = PollStatus.voteFailed;
    this.getVotingError('blankVote');
  }

  displayTestResult() {
    this.shouldDisplayTestBallot = true
  }


  postTestVote(ballot: any) {
    this.apiService.createTestBallot(this.pollId, ballot, this.validation, this.activePoll.round).subscribe(
      (res: any) => {
        this.testResults = JSON.parse(res.results);
        const list = this.testResults[0].indexOf(1);
        this.poll.rounds[this.electionSelected].displayedQuestions.forEach((question, questionIndex) => {
          // if (question.parent != null && question.parent == list) {
          //   if (this.testResults[questionIndex][0] == 1) {
          //     this.testDisplayedCandidates.push(new TestResult(question.question, question.links,
          //       question.listImages,
          //       question.listLink, true));
          //   } else {
          //     this.testDisplayedCandidates.push(new TestResult(question.question, question.links,
          //       question.listImages,
          //       question.listLink, false));
          //   }
          // }
        })

        this.testHash = this.sha(res['commit']);
        this.votingProof = JSON.stringify(res['commit']);
        this.setVoteSuccessMessage();
        this.getVotedStatus();
      },
      (err: any) => {
        this.status = PollStatus.voteFailed;
        if (err.status === 400) {
          if (err.error.error === 'Election is closed') {
            this.getVotingError('closed');
          }
          else if (err.error.error === 'Voter has already voted') {
            this.createAlreadyVotedError();
          } else {
            if (err.error.error === 'Invalid vote (blank vote + other answers)') {
              this.createBlankVoteError();
            } else {
              this.getVotingError('retry');
            }
          }
        } else {
          this.getVotingError('retry');
        }
        this.isVotingAnimation = false;
        this.isError = true;
      }
    );
  }

  postVote(ballot: any) {
    this.apiService.createBallot(this.pollId, ballot, this.validation, this.activePoll.round).subscribe(
      (res) => {
        this.votingProof = JSON.stringify(res);
        this.getVotedStatus();
        this.setVoteSuccessMessage();
        this.resetWalkthrough();
      },
      (err: any) => {
        this.status = PollStatus.voteFailed;
        if (err.status === 400) {
          if (err.error.error === 'Election is closed') {
            this.getVotingError('closed');
          }
          else if (err.error.error === 'Voter has already voted') {
            this.createAlreadyVotedError();
          } else {
            if (err.error.error === 'Invalid vote (blank vote + other answers)') {
              this.createBlankVoteError();
            } else {
              this.getVotingError('retry');
            }
          }
        } else {
          this.getVotingError('retry');
        }
        this.isVotingAnimation = false;
        this.isError = true;
      }
    );
  }

  encodePlurinominalRound(questionIndex: number) {
    const cryptoResponse = this.responses[questionIndex].join('');
    const responseIndex = this.cryptoChoices[questionIndex].findIndex(
      (x) => x.text === cryptoResponse
    );
    this.responses[questionIndex] = new Array(this.cryptoChoices[questionIndex].length).fill(0);
    this.responses[questionIndex][responseIndex] = 1;
  }

  createCryptoResponse(cryptedPoll: Poll, key: string, response: number[][]): any {
    let electionData: any;
    try {
      electionData = levote_JSONSerialObj.electionFromJSON(
        JSON.stringify(cryptedPoll)
      );
    } catch (e) {
      //this.getVotingError('retry');
    }

    const params = electionData.getParams();
    const jsonSerial = new levote_JSONSerial(params);
    const voterPrivKey = levote_VoterPrivateKeyObj.fromString(
      key,
      10
    );
    const voter0 = new levote_Voter(voterPrivKey, electionData, true);
    const ballot = voter0.generateBallot(response);
    const ballotJson = jsonSerial.toJSON(ballot);
    const commit = ballot.getBallotCommitment();
    const ballotCommitJson = jsonSerial.toJSON(commit);
    this.ballotSha = this.sha(ballotCommitJson); // Info a afficher port https://paragon-bps.atlassian.net/browse/V8TE-1853
    return ballotJson;
  }

  calculateVote() {
    if (!this.poll.bc) {
      const uncryptedResponse = {
        pubkey: this.privateKey,
        ballot: this.responses,
      };
      this.finalVote = JSON.stringify(uncryptedResponse);
    } else {
      this.activePoll.displayedQuestions.forEach((value, index) => {
        if (value.numberOfVote > 1) {
          this.encodePlurinominalRound(index);
        }
      });
      this.finalVote = this.createCryptoResponse(this.activePoll, this.privateKey, this.responses);
    }
    console.log(this.finalVote);
  }

  actionVote() {
    this.isVotingAnimation = true;
    this.isTestModeActive ? this.postTestVote(this.finalVote) : this.postVote(this.finalVote);
  }

  selectionHandler(index: number) {
    const next = [...this.localAnswers];
    next[index] = next[index] === 1 ? 0 : 1;

    this.localAnswers = next;
    this.isVoteValid = next.includes(1);

  }

  setActiveElection(event: number) {
    this.electionSelected = event;
    if (event === -1) {
      this.resetWalkthrough();
      return;
    }
    this.activePoll = new Poll(this.isTestModeActive ? this.testPoll : this.poll, this.electionSelected);
    this.route.queryParams.subscribe((params) => {
      if (event === 0) {
        this.privateKey = params.key;
      } else {
        const paramName = 'round' + this.activePoll.round;
        this.privateKey = params[paramName];
      }
    });
    this.cryptoChoices = this.activePoll.questions.map(a => a.answers.map(b => new Choice(b)))
  }

  setActiveList(event: number) {
    this.displayedCandidates = this.poll.rounds[this.electionSelected].displayedQuestions.filter(q => q.parent == event);
    const indexes = [];
    this.poll.rounds[this.electionSelected].displayedQuestions.forEach((q, index) => {
      if (q.parent == event) indexes.push(index - 1);
    });

    this.displayedCandidates.forEach((question, questionIndex) => {
      this.displayedCandidates[questionIndex].links[0] = this.poll.rounds[this.electionSelected].displayedQuestions[0].links[indexes[questionIndex]]
    })

    this.localAnswers = this.results[this.electionSelected][event]

    this.listSelected = event;
  }

  toggleDescription(): void {
    this.isDescriptionExpanded = !this.isDescriptionExpanded;
  }

  getTruncatedDescription(): string {
    if (!this.poll || !this.poll.description) {
      return '';
    }
    if (this.poll.description.length <= 100) {
      return this.poll.description;
    }
    return this.poll.description.substring(0, 100) + '...';
  }

  getCurrentFormattedDate(): string {
    const now = new Date();
    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const year = now.getFullYear();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');

    return `${day}/${month}/${year} à ${hours}:${minutes}:${seconds}`;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.isTestModeActive && !changes.isTestModeActive.firstChange) {
      this.resetWalkthrough();
    }

    this.pollId = this.poll ? this.poll.uuid : '';
    this.blockchainUrl = environment.settings.validation + this.pollId + '/' + this.poll.rounds[0].round + this.common.getNewEnvironmentString();
    // console.log(this.poll);
    if (!this.availableElections()) {
      this.status = PollStatus.alreadyVoted;
    } else {
      this.status = PollStatus.list;
    }
    this.getVotedStatus();

  }

  initResults() {

    console.log(this.poll);

    this.poll.rounds.forEach((round, roundIndex) => {
      let i = 0;
      this.results[roundIndex] = []
      round.displayedQuestions.forEach((question, questionIndex) => {
        if (question.parent != null && question.parent >= 0) {
          if (this.results[roundIndex][question.parent] == undefined) {
            i = 0
            this.results[roundIndex][question.parent] = []
          }
          this.results[roundIndex][question.parent].push(1);
          i++;
        }
      })
    })
  }

  ngOnInit() {
    this.initResults()
    this.blockchainUrl = environment.settings.validation + this.pollId + '/' + this.poll.rounds[0].round + this.common.getNewEnvironmentString();
  }
}
